import React from "react";
import { MdFilterListOff } from "react-icons/md";

const UserFilters = ({ filters, onFilterChange, onResetFilters, roles = [], promotions = [] }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onFilterChange({ [name]: value });
  };

  return (
    <div className="mb-6 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-sm font-medium text-gray-700">Filtres avancés</h3>
        <button
          onClick={onResetFilters}
          className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
        >
          <MdFilterListOff className="h-4 w-4" />
          <span>Réinitialiser</span>
        </button>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div>
          <label htmlFor="role" className="block text-xs font-medium text-gray-700">
            Rôle
          </label>
          <select
            id="role"
            name="role"
            value={filters.role || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="">Tous les rôles</option>
            {roles.map(role => (
              <option key={role.role_id} value={role.role_id}>
                {role.role_name}
              </option>
            ))}
          </select>
        </div>
        
        <div>
          <label htmlFor="status" className="block text-xs font-medium text-gray-700">
            Statut
          </label>
          <select
            id="status"
            name="status"
            value={filters.status || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="">Tous les statuts</option>
            <option value="active">Actif</option>
            <option value="inactive">Inactif</option>
          </select>
        </div>
        
        <div>
          <label htmlFor="promotion" className="block text-xs font-medium text-gray-700">
            Promotion
          </label>
          <select
            id="promotion"
            name="promotion"
            value={filters.promotion || ""}
            onChange={handleInputChange}
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500"
          >
            <option value="">Toutes les promotions</option>
            {promotions.map(promo => (
              <option key={promo.id_prom} value={promo.id_prom}>
                {promo.name_prom}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default UserFilters;